module.exports = __webpack_public_path__ + "img/conny-stage7.f709e9c5.png";